module.exports = __webpack_public_path__ + "static/media/em-113.883489a6.png";